module.exports = "export default __webpack_public_path__ + &quot;8704e1dc25d8b94a6cd6f022c644f390.svg&quot;;"